module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Acknowledgements"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Listofillustrations"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Part01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part I: The Greek World")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("Chapter 1")])]), _vm._v(" The Battle of Cunaxa (401 "), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("BCE")]), _vm._v(")")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("Chapter 2")])]), _vm._v(" The Battle of Issus (333 "), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("BCE")]), _vm._v(")")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part II: The Roman World")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("Chapter 3")])]), _vm._v(" The Battle of Cannae (216 "), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("BCE")]), _vm._v(")")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("Chapter 4")])]), _vm._v(" The Sieges of Jerusalem (70 "), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("CE")]), _vm._v(") and Masada (72–74 "), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("CE")]), _vm._v(")")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part III: Late Antiquity")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("Chapter 5")])]), _vm._v(" The Battle of Strasbourg (357 "), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("CE")]), _vm._v(")")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "space1"
  }, [_vm._v("Chapter 6")])]), _vm._v(" The Siege of Edessa (544 "), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("CE")]), _vm._v(")")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Conclusion")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Notes and References")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography and Further Reading")])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 66
// module chunks = 0